import {i18nContainer} from '@wallaby-ui/core';
import * as React from 'react';
import {connect, ConnectedProps} from 'react-redux';

import Chart from 'src/js/containers/chart/components/Chart';
import {getReportData} from 'src/js/containers/reports/reports_selectors';
import {usePlotlyLocaleInit} from 'src/js/hooks';
import {ChartReportConfig} from 'src/js/model/reports_config';
import {RootState} from 'src/js/store';

interface OwnProps {
  reportConfig: ChartReportConfig;
}

const mapState = (state: RootState, props: OwnProps) => ({
  reportData: getReportData(state, props),
  currentLocale: state[i18nContainer.I18N_REDUCER_STATE_ID].currentLocale,
  i18nConfig: state[i18nContainer.I18N_REDUCER_STATE_ID].i18nConfig,
});

const connector = connect(mapState);
type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & OwnProps;

const ReportChartContainer: React.FC<Props> = (props) => {
  const {i18nConfig, reportConfig, reportData, currentLocale} = props;
  usePlotlyLocaleInit(i18nConfig, currentLocale);

  /* eslint-enable import/no-dynamic-require, global-require */

  return i18nConfig && i18nConfig.isLoaded() ? (
    <Chart reportConfig={reportConfig} reportData={reportData} />
  ) : null;
};

export default connector(ReportChartContainer);
